import { useQuery, useMutation } from "@tanstack/react-query"
import { sdk } from "@/api/sdk"
import { queryClient } from "./client"

export const useRedfinAutocomplete = (region: string | null) => {
  return useQuery({
    queryKey: ["redfin-autocomplete", region],
    queryFn: async () => {
      if (!region || region === "") {
        return null // Return null if no region is specified or if it's an empty string
      }
      try {
        const response = await sdk.GetRedfinAutocomplete({ region })
        return response.redfinAutocomplete
      } catch (err) {
        console.error("Error fetching Redfin autocomplete:", err)
        throw err
      }
    },
    enabled: !!region, // Only execute the query if region is truthy
  })
}

export const useMarketData = (latitude?: number, longitude?: number) => {
  return useQuery({
    queryKey: ["marketData", latitude, longitude],
    queryFn: async () => {
      try {
        const params = {
          latitude: latitude ?? null,
          longitude: longitude ?? null,
        }
        const response = await sdk.MarketData(params)
        // console.log(`****-> ${JSON.stringify(response)}`)
        return response.marketDataQuery
      } catch (err) {
        console.error("Error fetching market data:", err)
        throw err
      }
    },
  })
}

export const useUpdateMarketData = () => {
  return useMutation({
    mutationFn: async (
      data: {
        city?: string | null
        state?: string | null
        zipcode?: string | null
      } = {}
    ) => {
      try {
        const { city, state, zipcode } = data
        const response = await sdk.UpdateUserMarketData({
          city,
          state,
          zipcode,
        })
        return response
      } catch (err) {
        console.error("Error updating market data:", err)
        throw err
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["marketData"] })
    },
  })
}
